/* import __COLOCATED_TEMPLATE__ from './target-hits-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import ReportingTooltip from 'embercom/components/tooltips/reporting-chart-datum';

export default class TargetHitsTooltip extends ReportingTooltip {}
